<template>
  <div class="a-page">
    <div class="bg-white min-h-screen !py-[10px] !px-[20px] space-y-12">
      <!-- GÓI ĐANG BÁN -->
      <section>
        <h2 class="text-3xl font-bold text-gray-800 mb-6">
          Gói sản phẩm Atosa - Trợ lý Shopee Marketing
        </h2>

        <div
          class="mt-[10px] grid grid-cols-1 md:grid-cols-2 gap-6 bg-gradient-to-b from-blue-100 to-blue-50 p-6 rounded-2xl">
          <div
            v-for="pkg in sellingPackages"
            :key="pkg.id"
            class="relative bg-white rounded-2xl shadow-xl border border-blue-300 p-6 hover:shadow-2xl transition-all flex flex-col justify-between ring-1 ring-blue-100"
          >
            <div>
            <span
              class="absolute top-4 right-4 bg-orange-400 text-white px-3 py-1 text-sm font-semibold rounded-full shadow-md">
              💰 {{ formatPrice(pkg.price) }}
            </span>
              <span v-if="pkg.is_active"
                    class="absolute top-4 left-4 bg-green-200 text-green-800 px-3 py-1 text-xs font-bold uppercase tracking-wider rounded-full shadow">
              Đang sử dụng
            </span>
              <div class="text-xl font-bold text-gray-800 mb-2 mt-10 tracking-wide">{{ pkg.name }}</div>
              <ul class="list-disc list-inside text-gray-700 space-y-2 mb-6">
                <li v-for="(feature, index) in pkg.features" :key="index">✨ {{ feature }}</li>
              </ul>
            </div>
            <button
              class="mt-auto w-full bg-gradient-to-r from-blue-600 to-blue-500 text-white py-2.5 rounded-xl hover:from-blue-700 hover:to-blue-600 transition-all text-sm font-semibold shadow-md"
            >
              🚀 Mua Gói
            </button>
          </div>
        </div>
      </section>

      <!-- GÓI ĐANG DÙNG -->
      <section>
        <h2 class="text-2xl font-bold text-gray-800 mb-6">✅ Gói sản phẩm đang dùng</h2>
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div
            v-for="pkg in activePackages"
            :key="pkg.id"
            class="flex items-center bg-gradient-to-r from-white to-gray-50 rounded-xl border border-gray-200 shadow p-4 hover:shadow-md transition"
          >
            <img :src="pkg.icon" alt="icon" class="w-12 h-12 mr-4 rounded-full border border-gray-300"/>
            <div class="flex-1">
              <div class="font-semibold text-gray-900">{{ pkg.name }}</div>
              <div class="text-sm text-gray-500">
                Bản quyền đến:
                <span class="text-red-500 font-medium">{{ formatDate(pkg.expiry) }}</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- GÓI ĐÃ MUA -->
      <section>
        <div class="flex items-center justify-between mb-6">
          <h2 class="text-2xl font-bold text-gray-800">📦 Gói sản phẩm đã mua</h2>
          <a href="#" class="text-sm text-blue-600 hover:underline">Xem chi tiết</a>
        </div>
        <div class="space-y-4">
          <div
            v-for="pkg in purchasedPackages"
            :key="pkg.id"
            class="flex items-center bg-white rounded-xl border border-gray-200 shadow p-4 hover:shadow-md transition"
          >
            <img :src="pkg.icon" alt="icon" class="w-12 h-12 mr-4 rounded-full border border-gray-300"/>
            <div class="flex-1">
              <div class="font-semibold text-gray-800">{{ pkg.name }}</div>
              <div class="text-sm text-gray-500">Số lượng gói: <span class="font-medium text-gray-700">{{
                  pkg.quantity
                }}</span></div>
            </div>
            <button
              class="ml-4 px-4 py-2 text-sm font-semibold bg-gray-100 hover:bg-gray-200 rounded-lg border border-gray-300 shadow">
              Áp dụng ngay
            </button>
          </div>
        </div>
        <p class="mt-6 text-sm text-gray-500 italic">
          Khi gói đang dùng hết thời hạn bản quyền, hệ thống sẽ tự lấy gói đã mua để gia hạn. Bạn có thể áp dụng gói đã
          mua để reset bộ đếm kho và tăng thời hạn bản quyền 1 tháng.
        </p>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductPackages',
  data() {
    return {
      sellingPackages: [
        {
          id: 1,
          name: 'ATOSA AGENT - ECO',
          price: 200000,
          features: ['Giới hạn sản phẩm', 'Tạo Flash Sale', 'Đăng ký sự kiện'],
          is_active: true
        },
        {
          id: 2,
          name: 'ATOSA AGENT - ULTRA',
          price: 500000,
          features: ['Không giới hạn', 'Tự động tạo sự kiện', 'Hiệu suất tối đa'],
          is_active: false
        }
      ],
      activePackages: [
        {
          id: 1,
          name: 'ShopeeSellerPhone [10K]',
          expiry: '2024-02-14T14:30:00',
          icon: 'https://via.placeholder.com/48x48?text=ea'
        },
        {
          id: 2,
          name: 'TikTok Shop Analysis [3K]',
          expiry: '2024-03-30T10:32:00',
          icon: 'https://via.placeholder.com/48x48?text=ea'
        },
        {
          id: 3,
          name: 'Atome Ads Starter [230K]',
          expiry: '2025-06-17T22:20:00',
          icon: 'https://via.placeholder.com/48x48?text=ea'
        }
      ],
      purchasedPackages: [
        {
          id: 1,
          name: 'Shopee Marketing - Atosa Pro [1.000K]',
          quantity: 18,
          icon: 'https://via.placeholder.com/48x48?text=ea'
        },
        {
          id: 2,
          name: 'Shopee Marketing - Atosa Basic [10K]',
          quantity: 3,
          icon: 'https://via.placeholder.com/48x48?text=ea'
        },
        {
          id: 3,
          name: 'Shopee Marketing - Atosa Vip1 [2.000K]',
          quantity: 6,
          icon: 'https://via.placeholder.com/48x48?text=ea'
        }
      ]
    };
  },

  beforeMount() {
    this.m__get_package_list()
  },

  methods: {
    async m__get_package_list() {

      const response = await this.$http.get(this.API.get_system_package_available_shopee_marketing, this.cf())
      this.marketing_pack = response.body.data

      // const response_analysis = await this.$http.get(this.API.get_system_package_available_shopee_marketing_analysis, this.cf())
      // this.marketing_pack.push(...response_analysis.body.data)

      const response_advanced = await this.$http.get(this.API.get_system_package_available_shopee_marketing_advanced, this.cf())
      this.advanced_pack = response_advanced.body.data

      const response_atosa_agent = await this.$http.get(this.API.get_system_package_available_atosa_agent, this.cf())
      this.atosa_agent_pack = response_atosa_agent.body.data

      const response_survey = await this.$http.get(this.API.get_system_package_available_shopee_marketing_survey, this.cf())
      this.analysis_pack = response_survey.body.data
      // data.push(...response_survey.body.data)

      const tiktok_shop_analysis = await this.$http.get(this.API.get_system_package_available_tiktok_shop_analysis, this.cf())
      this.tiktok_pack = tiktok_shop_analysis.body.data
    },

    formatPrice(value) {
      return value.toLocaleString('vi-VN') + 'đ';
    },
    formatDate(dateStr) {
      const d = new Date(dateStr);
      return (
        d.toLocaleDateString('vi-VN') +
        ' ' +
        d.toLocaleTimeString('vi-VN', {
          hour: '2-digit',
          minute: '2-digit'
        })
      );
    }
  }
};
</script>

<style scoped>
/* Tăng hiệu ứng cho shadow và background của card nếu cần */
</style>



// WEBPACK FOOTER //
// src/pages/package/new.vue